import { HookFormDropDownInput } from 'components/uikit/inputs/dropdown/HookFormDropDownInput';
import dropdownStyles from 'components/uikit/DropdownSelector.module.scss';
import styles from './UrlTypeDropDownInput.module.scss';
import { clsx } from 'clsx';
import { UrlType } from 'services/api/api-client';
import { FieldValues, Path, UseControllerProps } from 'react-hook-form';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';

export function UrlTypeDropDownInput<TFieldValues extends FieldValues>({
  name,
  formControl,
  errorMessage,
  placeholder,
  disabled,
}: {
  name: Path<TFieldValues>;
  errorMessage?: string;
  placeholder?: string;
  formControl: UseControllerProps<TFieldValues>['control'];
  disabled?: boolean;
}) {
  const urlTypes = Object.values(UrlType);
  const i18n = useScopedTranslation('Enums.UrlType');

  return (
    <HookFormDropDownInput
      name={name}
      className={clsx(styles.urlTypeSelector, dropdownStyles.selector)}
      options={urlTypes}
      getOptionLabel={i18n.t}
      classes={dropdownClasses}
      endAdornmentClassname={clsx({ [styles.expandIconDisabled]: disabled })}
      control={formControl}
      defaultValue={UrlType.Default}
      required={true}
      errorText={errorMessage}
      placeholder={placeholder}
      enableSearch={true}
      disabled={disabled}
    />
  );
}

const dropdownClasses = {
  option: dropdownStyles.selectorOption,
  paper: dropdownStyles.selectorPaper,
  popper: dropdownStyles.selectorPopper,
  input: styles.urlTypeSelector,
};
